import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../components/modal";
import { cancelSubscription } from "../../../../../../services/manager/signature.service";
import formatCurrency from "../../../../../../utils/formatCurrency";
import { ModalSignature } from "../../../../subscriptions/modal-signature";

export const CardSignatureDetail = (props: any): JSX.Element => {
	const { t: translation } = useTranslation();
	const { user, setUser } = props;

	const [showModalSignature, setShowModalSignature] =
		useState<boolean>(false);
	const [isRenewSignature, setIsRenewSignature] = useState<boolean>(false);
	const [loadingModal, setLoadingModal] = useState<boolean>(false);
	const [showCancelSignatureNotice, setShowCancelSignatureNotice] =
		useState<boolean>(false);
	const [responseSignature, setResponseSignature] = useState<any>();

	const handleSignature = (newSignature: boolean) => {
		setIsRenewSignature(newSignature);
		setShowModalSignature(true);
	};

	const handleCancelSignature = () => {
		setShowCancelSignatureNotice(true);
	};

	const onSubmitCancelSignature = () => {
		setLoadingModal(true);
		cancelSubscription(user.signature ? user.signature.id : "")
			.then(() => {
				toast.success(`Assinatura cancelada com sucesso!`);
				setUser({ ...user, signature: null });
				setShowCancelSignatureNotice(false);
				setLoadingModal(false);
			})
			.catch((error: any) => {
				console.log(error);
				setLoadingModal(false);
			});
	};

	useEffect(() => {
		if (responseSignature) {
			user.signature = responseSignature;
			setUser({ ...user, signature: responseSignature });
		}
	}, [responseSignature]);

	return (
		<>
			<Card className="card-detail">
				<Form>
					<Card.Body>
						<Card.Title>
							<Row>
								<Col
									xs={12}
									className="d-flex align-items-center"
								>
									<h4
										className="mb-0 text-darker-grey"
										style={{
											fontSize: "18px",
											color: "#333333",
											fontWeight: 600,
										}}
									>
										{translation(
											"userAccount.signature.label"
										)}
									</h4>
								</Col>
							</Row>
						</Card.Title>
						<Row className="mt-3 p-0">
							<hr />
						</Row>
						<Row>
							<Col
								md={12}
								className="d-flex align-items-center"
							>
								<Row className="col-11">
									<Col xs={12}>
										<Row>
											{user.signature ? (
												<>
													<Col
														sm={6}
														className="mt-2"
													>
														<p>
															<span className="text-darker-grey">
																Termina em{" "}
																{moment(
																	user
																		.signature
																		.end
																).format("LL")}
															</span>{" "}
														</p>
														{!!user.plan ? (
															<>
																<p>
																	<span className="text-darker-grey">
																		Plano
																		Atual:{" "}
																	</span>{" "}
																	{
																		user
																			.plan
																			.name
																	}
																</p>
																<p>
																	<span className="text-darker-grey">
																		Quantidade
																		de
																		materiais:{" "}
																	</span>{" "}
																	Até{" "}
																	{
																		user
																			.plan
																			.materials_max
																	}{" "}
																	disciplinas{" "}
																</p>
																<p>
																	<span className="text-darker-grey">
																		Valor:{" "}
																	</span>{" "}
																	{formatCurrency(
																		user
																			.plan
																			.parcel
																	)}
																	/mês{" "}
																</p>
															</>
														) : (
															<p>
																<span className="text-darker-grey">
																	Assinatura
																	sem plano
																	vinculado
																</span>{" "}
															</p>
														)}
													</Col>

													<Col sm={6}>
														<Row>
															<Col
																sm={12}
																className="d-flex justify-content-end"
															>
																<Button
																	variant="link"
																	style={{
																		textDecoration:
																			"none",
																	}}
																	onClick={() =>
																		handleSignature(
																			false
																		)
																	}
																>
																	{translation(
																		"manager.subscription.renew"
																	)}
																</Button>
																{/* <Button id="renewSignature" variant="link" style={{ textDecoration: 'none' }} onClick={() => history.push('/contact?subject=Renovação')}>{translation('userAccount.signature.renew')}</Button> */}
															</Col>
															<Col
																sm={12}
																className="d-flex justify-content-end"
															>
																<Button
																	variant="link"
																	style={{
																		textDecoration:
																			"none",
																	}}
																	onClick={() =>
																		handleCancelSignature()
																	}
																>
																	{translation(
																		"userAccount.signature.cancel"
																	)}
																</Button>
															</Col>
														</Row>
													</Col>
												</>
											) : (
												<>
													<Col sm={12}>
														<Button
															variant="link"
															style={{
																textDecoration:
																	"none",
															}}
															onClick={() =>
																handleSignature(
																	true
																)
															}
														>
															{translation(
																"manager.subscription.new"
															)}
														</Button>
													</Col>
												</>
											)}
										</Row>
									</Col>
								</Row>
							</Col>
						</Row>
					</Card.Body>
				</Form>
			</Card>

			<ModalSignature
				showModal={showModalSignature}
				setShowModal={setShowModalSignature}
				isNewSignture={isRenewSignature}
				user={user}
				loading={loadingModal}
				setLoading={setLoadingModal}
				setResponseSignature={setResponseSignature}
			/>

			<Modal
				headerTitle="Aviso"
				submitButtonText={translation("manager.user.confirm")}
				show={showCancelSignatureNotice}
				onHide={() => setShowCancelSignatureNotice(false)}
				onSubmit={onSubmitCancelSignature}
				variant="confirm-modal-default"
				loading={loadingModal}
			>
				<p>
					Tem certeza que deseja cancelar a assinatura do usuário{" "}
					<b>{user.name}</b>?
				</p>
			</Modal>
		</>
	);
};
